import React, { useEffect } from 'react'
import { navigate } from 'gatsby'
import parse from 'html-react-parser'
import { getDateTime, getTextShort } from '@helpers/helper.novelty'
import ImageGallery from 'react-image-gallery'
import { Novelty, RealEstateDataPageComponentData, TagMediacore } from 'types'
import { ElementHTML, makeShareUrl } from '@helpers/helper.rendering'
import { useDispatch } from 'react-redux'
import { setActiveTags } from '@slices/noveltiesSlice'
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappIcon,
} from 'react-share'
import { Col, Row } from 'react-bootstrap'

interface ExternalProps {
  id: string
  detail?: Novelty
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const isBrowser = typeof window !== 'undefined'

const Detail_Novelty_3 = (props: CombinedProps) => {
  const {
    global_data,
    titleElement,
    titleColor,
    titleHexa,
    dateElement,
    authorElement,
    subtitleColor,
    subtitleHexa,
  } = props
  const dispatch = useDispatch()

  const { divisionPath } = global_data
  const BlogDetailData = props.detail
  const isLoadingDetailData = false

  const imagesToShow = BlogDetailData?.images_data?.map((image) => ({
    original: image.file as string,
    thumbnail: image.file as string,
    description: image.text_alt ?? '',
    text_alt: image.text_alt ?? '',
  }))

  useEffect(() => {
    if (BlogDetailData) {
      if (isBrowser) {
        window.scrollTo(0, 0)
      }
    }
  }, [BlogDetailData])

  const formateMessage = (str: string) => {
    return encodeURIComponent(str)
      .replace(/[!'()]/g, escape)
      .replace(/\*/g, '%2A')
  }

  return (
    <section className="novelty novelty-detail c">
      <div className="container-fluid">
        <div className="row">
          {isLoadingDetailData ? (
            <>
              <div className="d-block d-lg-none"></div>
              <div className="d-none d-lg-block"></div>
            </>
          ) : (
            <>
              <div className="div_header_novelty col-12 col-lg-12 pe-lg-5 mb-5">
                <img
                  className=" py-4 image-novelty"
                  src={BlogDetailData?.image}
                  alt=""
                />
                {/* <span className="legend">{BlogDetailData?.footer ?? ''}</span> */}
                <ElementHTML
                  children={BlogDetailData?.title ?? ''}
                  elementType={titleElement ?? 'h1'}
                  className={`title ${titleColor} mt-lg-4 mt-4`}
                  style={{ color: titleHexa }}
                />
                <h2
                  className={`subtitle ${subtitleColor} mt-4 mb-lg-5 mb-5`}
                  style={{ color: subtitleHexa }}
                >
                  {getTextShort(BlogDetailData?.headline ?? '', 500)}
                </h2>
              </div>
              <div className="first_div col-12 col-lg-9 pe-lg-5">
                <Row className="d-flex justify-content-between">
                  <Col
                    lg={8}
                    xs={12}
                  >
                    <ElementHTML
                      children={getDateTime(BlogDetailData?.date_published, true)}
                      elementType={dateElement ?? 'h4'}
                      className={`mb-3 d-flex`}
                    />
                  </Col>
                  <Col
                    lg={4}
                    xs={12}
                  >
                    {BlogDetailData?.author && (
                      <div className="d-flex align-items-center justify-content-start justify-content-lg-end">
                        <ElementHTML
                          children={`Publicado por `}
                          elementType={authorElement ?? 'h4'}
                          className="legend me-2"
                          style={{ fontWeight: 'bold' }}
                        />
                        <ElementHTML
                          children={BlogDetailData?.author}
                          elementType={authorElement ?? 'h4'}
                          className="legend"
                        />
                      </div>
                    )}
                  </Col>
                </Row>
                <div className="col-12 col-lg-12 div_body_novelty mt-lg-4 mt-4">
                  {BlogDetailData?.content ? <div> {parse(BlogDetailData?.content)}</div> : ''}
                </div>
                <div className="div_gallery mt-5 text-center ">
                  {!!imagesToShow?.length && (
                    <ImageGallery
                      showPlayButton={false}
                      showIndex
                      showBullets
                      // autoPlay
                      items={imagesToShow}
                    />
                  )}
                </div>
                <div className="div_footer_novelty col-12 col-lg-12">
                  <div className=" col-12 mt-5 text-start">
                    <a
                      onClick={() => navigate((divisionPath ?? '') + '/novedades')}
                      className="btn btn-primary"
                    >
                      VOLVER A NOVEDADES
                    </a>
                  </div>
                </div>
              </div>
              <div className="second_div col-12 col-lg-3 pe-lg-5 ps-lg-5">
                {!!BlogDetailData?.files_data?.length ? (
                  <>
                    <h2
                      className={`${subtitleColor} mb-5`}
                      style={{ color: subtitleHexa }}
                    >
                      Archivos
                    </h2>
                    {BlogDetailData?.files_data?.map((files: any) => (
                      <div
                        key={files.id}
                        className={'btn btn-primary border linkStyled mb-3'}
                      >
                        <a
                          href={files.file}
                          className="download_link"
                        >
                          {files.file
                            .substring(files.file.indexOf('news/'), files.file.length)
                            .substring(5)}
                        </a>
                      </div>
                    ))}
                  </>
                ) : (
                  []
                )}
                {!!BlogDetailData?.tags?.length ? (
                  <>
                    <h2
                      className={`${subtitleColor} my-5`}
                      style={{ color: subtitleHexa }}
                    >
                      Etiquetas de filtrado
                    </h2>
                    {BlogDetailData?.tags?.map((tag: TagMediacore, index: number) => (
                      <span
                        key={index}
                        className="tagPill mt-2 mb-lg-2 mt-lg-0 me-2"
                        onClick={() => {
                          dispatch(setActiveTags([tag.id])),
                            navigate((divisionPath ?? '') + '/novedades')
                        }}
                      >
                        {tag.name}
                      </span>
                    ))}
                  </>
                ) : (
                  []
                )}
                <h2
                  className={`${subtitleColor} my-5`}
                  style={{ color: subtitleHexa }}
                >
                  Compartir
                </h2>
                <div className="d-flex justify-content-start shared-buttons align-items-end">
                  <a
                    className="mx-1 ms-2 me-0 ms-lg-3"
                    href={
                      'https://api.whatsapp.com/send?text=' +
                      formateMessage(
                        BlogDetailData?.title +
                          ': ' +
                          makeShareUrl({
                            novelty: BlogDetailData,
                            href: location?.href,
                          }),
                      )
                    }
                    target="_blank"
                  >
                    <WhatsappIcon
                      size={48}
                      bgStyle={{ fill: 'transparent' }}
                      iconFillColor="var(--primaryColor)"
                    />
                  </a>
                  <EmailShareButton
                    className="mx-1 ms-2 me-0 ms-lg-3"
                    body={
                      BlogDetailData?.title +
                      ' ' +
                      makeShareUrl({
                        novelty: BlogDetailData,
                        href: location?.href,
                      })
                    }
                    subject={BlogDetailData?.title}
                    url={''}
                  >
                    <EmailIcon
                      size={48}
                      bgStyle={{ fill: 'transparent' }}
                      iconFillColor="var(--primaryColor)"
                    />
                  </EmailShareButton>
                  <FacebookShareButton
                    className="mx-1 ms-2 me-0 ms-lg-3"
                    url={makeShareUrl({
                      novelty: BlogDetailData,
                      href: location?.href,
                    })}
                    quote={BlogDetailData?.title}
                  >
                    <FacebookIcon
                      size={48}
                      bgStyle={{ fill: 'transparent' }}
                      iconFillColor="var(--primaryColor)"
                    />
                  </FacebookShareButton>
                  <TwitterShareButton
                    className="mx-1 TwitterShareButton ms-2 me-0 ms-lg-3"
                    url={makeShareUrl({
                      novelty: BlogDetailData,
                      href: location?.href,
                    })}
                    title={BlogDetailData?.title}
                  >
                    <i className={`icon-twitter twitterCustomIcon`} />
                  </TwitterShareButton>
                  <LinkedinShareButton
                    url={makeShareUrl({
                      novelty: BlogDetailData,
                      href: location?.href,
                    })}
                    source={makeShareUrl({
                      novelty: BlogDetailData,
                      href: location?.href,
                    })}
                    title={BlogDetailData?.title}
                    className="mx-1 ms-2 me-0 ms-lg-3"
                  >
                    <LinkedinIcon
                      size={48}
                      bgStyle={{ fill: 'transparent' }}
                      iconFillColor="var(--primaryColor)"
                    />
                  </LinkedinShareButton>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  )
}

export default Detail_Novelty_3
